export function copyToClipboard(text: string): void {
  window.navigator.clipboard.writeText(text);
}
